<vdr-chip
  [icon]="removable ? 'times' : undefined"
  (iconClick)="remove.emit()"
  [title]="facetValue.facet.name + ' - ' + facetValue.name"
>
  <span *ngIf="displayFacetName" class="facet-name">{{
    facetValue.facet.name
  }}</span>
  <span>{{ facetValue.name }}</span>
</vdr-chip>
